import SelectMulti from 'ol-ext/control/SelectMulti'
import Select from 'ol-ext/control/Select'
import { chronologicalData, travels } from './source'
import { DEFAULT_END, DEFAULT_START, setDate, triggerDateChange } from './datepicker';

const selectYear = new Select({
  className: 'selectYear',
  source: chronologicalData,
});

const selectCountry = new Select({
  className: 'selectCountry',
  source: chronologicalData,
});

export const filterChronological = new SelectMulti({
  source: chronologicalData,
  className: 'chronologicalMultiselect',
  collapsed: false,
  // target: $('.multiselect').get(0),
  btInfo: 'Filter',
  controls: [
    selectCountry,
    selectYear,
  ]
});


$('.year').on('change', function () {
  filterChronological.doSelect({});
});

$('#switchCheckReverse').on("change", function () {
  if (this.checked) {
    selectYear.setConditions({
      usecase: false,
      all: true,
      conditions: [{
        attr: 'startDate',
        op: '>=',
        val: '1485'
      },
      {
        attr: 'endDate',
        op: '<=',
        val: '1548'
      }
      ]
    }
    );
    setDate(DEFAULT_START, DEFAULT_END)
    triggerDateChange(DEFAULT_START, DEFAULT_END);

    $('.minYear').val('1485')
    $('.maxYear').val('1548')

    selectYear.doSelect({});
    filterChronological.doSelect({});

  }
})


$(document).on('click', '.dropdown-menu', function () {
  var selected = [];
  var info = [];
  $('.dropdown-menu input:checked').each(function () {
    selected.push($(this).attr('id'));
    info.push($(this).attr('value'));

  });
  var infoText = ''
  for (var i = 0; i < info.length; i++) {
    infoText += info[i] + ' '
  }

  var result = selected.flatMap(
    (v, i) => selected.slice(i + 1).map(w => v + ',' + w)
  );

  var countriesList = []
  for (var i = 0; i < selected.length; i++) {
    countriesList.push(selected[i])
  }

  for (var i = 0; i < result.length; i++) {
    countriesList.push(result[i])
    var splitresult = result[i].split(',')
    countriesList.push(splitresult[1] + ',' + splitresult[0])
  }
  var conditions = []

  if (countriesList.length > 0) {

    for (var i = 0; i < countriesList.length; i++) {
      conditions.push({
        attr: 'countries',
        op: '=',
        val: countriesList[i]
      })
    }

  } else {
    conditions.push({
      attr: 'countries',
      op: '!=',
      val: 'none'
    })

  }

  selectCountry.setConditions({
    usecase: false,
    all: false,
    conditions: conditions
  }
  );

  $('#countriesInfo').html(infoText);

  selectCountry.doSelect({});
  filterChronological.doSelect({});
});